import {useState, useCallback} from 'react';

import {SearchBar} from './SearchBar';
import {ResultsList} from './SearchComponents';
import {SearchItem} from './SearchItem';

import type {SearchBarCoreProps} from './common';

type Props<T> = SearchBarCoreProps<T> & {
  labelRenderStrategy: (value: T) => React.ReactNode;
  select: (v: SearchBarCoreProps<T>['idProperty']) => void;
  lengthOfResults?: number;
};
export function SearchBarWithResults<
  // not worth the trouble
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Searchable extends Record<string, any>,
>({
  labelRenderStrategy,
  select,
  lengthOfResults,
  ...props
}: Props<Searchable>): React.JSX.Element {
  const [value, setValue] = useState('');
  const [results, setResults] = useState<string[]>([]);

  const handleChange = useCallback(
    (filtered: string[]): void => {
      setResults(filtered.slice(0, lengthOfResults ?? 5));
    },
    [lengthOfResults]
  );

  const handleSelect = (e: React.MouseEvent, result: string): void => {
    e.stopPropagation();
    select(result);
    setValue('');
    setResults([]);
  };

  return (
    <SearchBar<Searchable>
      handleSearchResults={handleChange}
      searchValue={value}
      setSearchValue={setValue}
      shouldClearOnBlur
      {...props}
    >
      {results.length ? (
        <ResultsList>
          {results.map((result) => (
            <SearchItem
              key={result}
              onMouseDown={(e) => handleSelect(e, result)}
            >
              {labelRenderStrategy(props.collection.byId[result])}
            </SearchItem>
          ))}
        </ResultsList>
      ) : null}

      {props.children}
    </SearchBar>
  );
}
